import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

/**
 * Fancybox module
 *
 * @package AGDS
 * @category Modules
 * @module Fancybox
 * @see AGDSApp
 * @author Andy Groove
 * @since 1.0.0
 */
export default class FancyboxModule {
    /**
     * Constructor
     *
     * @param {Object} options
     */
    constructor(options = {}) {
        this.fancyEls = options.fancyEls;
    }

    /**
     * Initialize
     */
    init() {
        if (typeof Fancybox === "undefined" || !this.fancyEls) {
            return;
        }

        const params = {
            ...Fancybox.defaults,
            autoFocus: false,
            trapFocus: false,
            compact: false,
            // touch: false,
            // dragToClose: false,
        };

        Fancybox.bind(this.fancyEls, params);
    }
}
